import axiosPrivate from "@services/axiosPrivate";

export const updateSupportTicket = (data) => {
    return axiosPrivate.post(`/updateSupportTicket`, data);
};